export const MENU_TYPE_HEADER = 1;
export const MENU_TYPE_FOOTER = 2;


// WEBPACK FOOTER //
// ./src/containers/menus/constants.js